var _path, _path2, _ellipse, _ellipse2, _path3, _circle, _path4, _path5, _circle2, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriendlyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M28.4142 21.4142L20.8414 13.8414C20.7154 13.7154 20.5 13.8047 20.5 13.9828V17.5478C20.5 18.1674 20.6918 18.7717 21.0491 19.2779L26.317 26.7407C26.4361 26.9094 26.5 27.1109 26.5 27.3174V33.5C26.5 34.0523 26.9477 34.5 27.5 34.5H37.5C38.0523 34.5 38.5 34.0523 38.5 33.5V28C38.5 24.6863 35.8137 22 32.5 22H29.8284C29.298 22 28.7893 21.7893 28.4142 21.4142Z",
    fill: "#F93749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M12.5858 21.4142L20.1586 13.8414C20.2846 13.7154 20.5 13.8047 20.5 13.9828V17.5478C20.5 18.1674 20.3082 18.7717 19.9509 19.2779L14.683 26.7407C14.5639 26.9094 14.5 27.1109 14.5 27.3174V33.5C14.5 34.0523 14.0523 34.5 13.5 34.5H3.5C2.94772 34.5 2.5 34.0523 2.5 33.5V28C2.5 24.6863 5.18629 22 8.5 22H11.1716C11.702 22 12.2107 21.7893 12.5858 21.4142Z",
    fill: "#F93749"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 32,
    cy: 19,
    rx: 2.5,
    ry: 3,
    fill: "#F93749"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.16,
    cx: 9,
    cy: 18,
    rx: 2.5,
    ry: 3,
    fill: "#F93749"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142 21.4142L20.8414 13.8414C20.7154 13.7154 20.5 13.8047 20.5 13.9828V17.5478C20.5 18.1674 20.6918 18.7717 21.0491 19.2779L26.317 26.7407C26.4361 26.9094 26.5 27.1109 26.5 27.3174V36C26.5 36.5523 26.9477 37 27.5 37H37.5C38.0523 37 38.5 36.5523 38.5 36V28C38.5 24.6863 35.8137 22 32.5 22H29.8284C29.298 22 28.7893 21.7893 28.4142 21.4142Z",
    stroke: "#F93749",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 18.5,
    r: 3.3,
    stroke: "#F93749",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5858 21.4142L20.1586 13.8414C20.2846 13.7154 20.5 13.8047 20.5 13.9828V17.5478C20.5 18.1674 20.3082 18.7717 19.9509 19.2779L14.683 26.7407C14.5639 26.9094 14.5 27.1109 14.5 27.3174V36C14.5 36.5523 14.0523 37 13.5 37H3.5C2.94772 37 2.5 36.5523 2.5 36V28C2.5 24.6863 5.18629 22 8.5 22H11.1716C11.702 22 12.2107 21.7893 12.5858 21.4142Z",
    stroke: "#F93749",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 28V35",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.3,
    transform: "matrix(-1 0 0 1 10 18.5)",
    stroke: "#F93749",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5L13 6",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.5L28 6",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.5V2",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 28V35",
    stroke: "#F93749",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendlyIcon);
export default __webpack_public_path__ + "static/media/friendly-icon.f9c2b5670c440d512c7e1581baba4f28.svg";
export { ForwardRef as ReactComponent };